export const formatCurrency = (value, options) =>
  value?.toLocaleString("en-US", {
    ...(options?.currencyDisplay !== "none" && {
      style: "currency",
      currency: "USD",
      currencyDisplay: options?.currencyDisplay || "symbol",
    }),
    maximumFractionDigits: options?.digits || 0,
    minimumFractionDigits: options?.digits || 0,
  });